export default __webpack_public_path__ + "static/media/devguide05.4be83df8.md";